import type { Product } from "@/types/product";

export const wineCategories = [
  "紅酒",
  "白酒",
  "粉紅酒",
  "香檳",
  "氣泡酒",
  "甜酒",
  "強化酒",
  "威士忌",
];

// ─────────────────────────────────────────────
// 國家（分組顯示；countries 為去重後的扁平清單）
// ─────────────────────────────────────────────
export interface OptionGroup {
  label: string;
  options: string[];
}

export const countryGroups: OptionGroup[] = [
  {
    label: "舊世界（歐洲）",
    options: [
      "法國", "義大利", "西班牙", "葡萄牙", "德國", "奧地利", "匈牙利",
      "希臘", "瑞士", "羅馬尼亞", "摩爾多瓦", "斯洛維尼亞", "克羅埃西亞",
      "塞爾維亞", "英國", "盧森堡",
    ],
  },
  {
    label: "新世界",
    options: [
      "美國", "加拿大", "澳洲", "紐西蘭", "智利", "阿根廷", "烏拉圭",
      "巴西", "墨西哥", "南非", "中國", "印度", "黎巴嫩", "以色列",
      "土耳其", "日本",
    ],
  },
  {
    label: "威士忌產區",
    options: ["蘇格蘭", "愛爾蘭"],
  },
];

export const countries: string[] = [...new Set(countryGroups.flatMap((g) => g.options))];

// ─────────────────────────────────────────────
// 葡萄品種／烈酒類型（分組顯示；grapes 為去重後的扁平清單）
// ─────────────────────────────────────────────
export const grapeGroups: OptionGroup[] = [
  {
    label: "紅葡萄",
    options: [
      "Cabernet Sauvignon", "Merlot", "Pinot Noir", "Syrah", "Shiraz", "Grenache",
      "Zinfandel", "Petit Verdot", "Carménère", "Malbec", "Cabernet Franc",
      "Gamay", "Mourvèdre", "Carignan", "Tempranillo", "Garnacha",
      "Nebbiolo", "Barbera", "Dolcetto", "Sangiovese", "Corvina",
      "Montepulciano", "Aglianico", "Primitivo", "Touriga Nacional", "Baga",
      "Mencía", "Xinomavro", "Tannat", "Bonarda", "Pinotage", "Blaufränkisch",
      "Saperavi",
    ],
  },
  {
    label: "白葡萄",
    options: [
      "Chardonnay", "Sauvignon Blanc", "Riesling", "Sémillon",
      "Gewürztraminer", "Viognier", "Chenin Blanc", "Pinot Gris", "Muscat",
      "Viura", "Roussanne", "Marsanne", "Albariño", "Verdejo", "Garganega", "Trebbiano", "Vermentino", "Fiano",
      "Greco", "Grüner Veltliner", "Furmint", "Assyrtiko", "Torrontés",
      "Colombard", "Silvaner",
    ],
  },
  {
    label: "混調",
    options: [
      "Cabernet Sauvignon Blend", "Merlot Blend", "Merlot / Cabernet Franc",
      "Pinot Noir Blend", "Syrah Blend", "Shiraz / Syrah", "Grenache Blend",
      "Tempranillo Blend", "Sangiovese Blend",
      "Cabernet Franc Blend", "Chardonnay Blend", "Sauvignon Blanc Blend",
      "Sémillon Blend", "Riesling Blend",
      "Pinot Noir / Chardonnay", "Chardonnay Pinot Noir", "Chardonnay / Pinot Noir",
      "Pinot Noir / Chardonnay / Meunier", "Chardonnay / Pinot Noir / Meunier",
      "GSM Blend", "Bordeaux Blend", "多品種混調",
    ],
  },
  {
    label: "威士忌／烈酒",
    options: [
      "Single Malt", "Blended Malt", "Blended", "Grain Whisky", "Bourbon",
      "Rye Whiskey",
    ],
  },
];

export const grapes: string[] = [...new Set(grapeGroups.flatMap((g) => g.options))];

export const products: Product[] = [];

// Category tag styles
export const categoryTagStyles: Record<string, string> = {
  "紅酒": "bg-accent-100 text-accent-800",
  "白酒": "bg-primary-100 text-primary-700",
  "粉紅酒": "bg-accent-50 text-accent-600",
  "香檳": "bg-secondary-100 text-secondary-800",
  "氣泡酒": "bg-secondary-50 text-secondary-700",
  "甜酒": "bg-primary-50 text-primary-600",
  "強化酒": "bg-foreground-50 text-foreground-600",
  "威士忌": "bg-foreground-100 text-foreground-700",
};
